import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTriangleNavbarCollapsed = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 7 7",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.29289 0.707105C5.92286 0.0771403 7 0.523309 7 1.41421V6C7 6.55228 6.55228 7 6 7H1.41421C0.523309 7 0.0771421 5.92286 0.707107 5.29289L5.29289 0.707105Z",
		fill: "#CBCBCB"
	})
});
export default SvgTriangleNavbarCollapsed;
